module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": -90,
      "size": 115,
      "width": 15,
      "value": _vm.value,
      "color": "primary"
    }
  }, [_vm._v("\n     " + _vm._s(_vm.value) + "%\n   ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-249212ce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/partials/progressCircularDonut.vue
// module id = 499
// module chunks = 0